import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { PersonDataService } from "../../core/persons.dataservice";
import { DetailsBase } from "../../settings/shared/details.base";

@Component({
    selector: "crew-person-overview",
    template: require('./person-overview.component.html')
})
export class PersonOverviewComponent extends DetailsBase<Nema.Crew.Model.Person> {
    
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('person') personEntity: Nema.Crew.Model.Person,
        @Inject(PersonDataService.Id) personDataService: PersonDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, personEntity, personDataService, $log);

        this.sharedSettings = Settings.instance;
    }

    public sharedSettings: Settings;

    public entityName = "Person";

    public editStateName = "app.resources.persons.edit";

    public listStateName = "app.resources.persons";
}

class Settings {
    public static instance: Settings = new Settings();

    public selectedTabIndex: number = 0;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/person-overview.component.ts